/** Password-reset URL helpers (DEC-Store: /login?mode=reset&token=). */
export const getResetTokenFromSearch = (search = '') => {
  const params = new URLSearchParams(search);
  if (params.get('mode') === 'reset') {
    return String(params.get('token') || '').trim();
  }
  return String(params.get('resetToken') || params.get('token') || '').trim();
};

export const isPasswordRecoveryUrl = (pathname = '', search = '') => {
  if (pathname === '/accept-invitation') return true;
  if (pathname === '/reset-password' || pathname === '/login') {
    const params = new URLSearchParams(search);
    if (params.get('mode') === 'reset' && params.get('token')) return true;
  }
  return Boolean(getResetTokenFromSearch(search));
};

export const clearAuthSession = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
